import { ApiService } from '../../app-lite/api/api.service';
import { TableService }  from '../../app-lite/table/table.service';

import VehicleHtml  from '../../app-lite/vehicles/vehicle.html';
import VehiclesHtml from '../../app-lite/vehicles/vehicles.html';

export function VehiclesStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller: 'VehicleCtrl',
    name      : 'app.vehicle',
    params    : {
      id: { squash: true, value: null }
    },
    templateUrl: VehicleHtml,
    url        : '/:customer_id/vehicle/:id',
    resolve    : {
      company           : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      customer          : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/customer', $stateParams.customer_id),
      inspectionStatuses: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/inspection_status_types', null, null, { bypass: true }),
      vehicleGroups     : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/vehicle_groups_selected', null, 'vehicleBodyTypes'),
      attachments       : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/vehicle_attachments/for_vehicle', $stateParams.id)
          : [],
      events: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('vehicleEvents');

        return $stateParams.id
          ? workshopAPI.get('/vehicles/event_list', [
            $stateParams.id,
            0,
            cache.paging.pageSize   || 5,
            cache.sorting.field     || 'event_date',
            cache.sorting.direction || 'desc'
          ])
          : [];
      },
      history: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('vehicleHistory');

        return $stateParams.id
          ? workshopAPI.get('/vehicles/vehicle_history_list', [
            $stateParams.id,
            0,
            cache.paging.pageSize   || 5,
            cache.sorting.field     || 'post_date',
            cache.sorting.direction || 'desc'
          ])
          : [];
      },
      inspections: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('vehicleInspections');

        return $stateParams.id
          ? workshopAPI.get('/vehicles/inspection_list', [
            $stateParams.id,
            0,
            cache.paging.pageSize   || 5,
            cache.sorting.field     || 'inspection_date',
            cache.sorting.direction || 'asc'
          ])
          : [];
      },
      invoices: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('vehicleInvoices');

        return $stateParams.id
          ? workshopAPI.get('/vehicles/invoice_list', [
            $stateParams.id,
            0,
            cache.paging.pageSize   || 5,
            cache.sorting.field     || 'post_date',
            cache.sorting.direction || 'desc'
          ])
          : [];
      },
      transactions: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/dealership_transaction_logs/index_for_vehicle', [ $stateParams.id, 0, 5 ])
          : [],
      vehicle: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.id
          ? workshopAPI.get('/vehicle', $stateParams.id)
          : ''
    }
  })
  .state({
    controller : 'VehiclesCtrl',
    name       : 'app.vehicles',
    templateUrl: VehiclesHtml,
    url        : '/vehicles',
    resolve    : {
      vehicles: ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('vehicles');

        return workshopAPI.stream('/filters', [
          cache.filtering.value ? cache.filtering.value : '*',
          'vehicles',
          0,
          cache.paging.pageSize   || 10,
          cache.sorting.field     || 'plate_number',
          cache.sorting.direction || 'asc',
          false
        ]);
      }
    }
  });
};